import { render, staticRenderFns } from "./_template-filters.vue?vue&type=template&id=2fd85d56&"
import script from "./_template-filters.vue?vue&type=script&lang=js&"
export * from "./_template-filters.vue?vue&type=script&lang=js&"
import style0 from "./_template-filters.vue?vue&type=style&index=0&id=2fd85d56&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports